import { Box, Button, IconButton, Stack, Typography } from "@mui/material"
import { useEffect, useState } from "react";
import ClearIcon from '@mui/icons-material/Clear';
import { cancelTask } from "../api/task";
import { TaskRecord, TaskStatus } from "../types/Task";

export const QueuedDeliverySimulation = (props: {
    taskRecord: TaskRecord | undefined,
    handleCanceled: () => void,
    changeState: (stateId: number) => void,
}) => {
    const {taskRecord, handleCanceled, changeState} = props;
    const [numberOfTask, setNumberOfTasks] = useState<number>(1);

    const handleSubmit = async () => {
        // if(taskRecord) {
        //     const result = await cancelTask({
        //         ...taskRecord,
        //         completedDatetime: new Date(),
        //         assignedDatetime: new Date(),
        //         status: TaskStatus.REQUEST_CANCELLED,
        //     });
        //     // console.log(result);
        //     handleCanceled();
        // }
        console.log("Do nothign")
    }

    useEffect(() => {
        const timer = setTimeout(() => {
            changeState(2) // 2 grab page
            }, 2500)
        return () => clearTimeout(timer)
    }, [])

    return <>
    <Box sx={{
        backgroundColor: "#eae6d0",
        height: "128px",
    }}>
        <Stack direction={"row"}>
            <Box sx={{
                width: "85%"
            }}>
                <Typography sx={{
                    fontSize: "28px",
                    fontWeight: "bold",
                    paddingLeft: "20px",
                    // paddingBottom: "6px",
                    paddingTop: "12px",
                }}>Waiting for availability of the robot</Typography>
            <Typography sx={{
                    fontSize: "22px",
                    paddingLeft: "20px",
                    paddingBottom: "24px",
                }}>Robot is hard at work, please wait a moment</Typography>
            </Box>
            <img src="./assets/hourglass.png" alt="hourglass" height={"150px"} style={{
                    bottom: "-15px",
                    position: "relative",
                    paddingRight: "36px"
                }}/>
        </Stack>
    </Box>
    <Stack direction="column" alignItems={"center"} justifyContent={"center"} >
            {/* <Typography fontWeight="bold" sx={{
                fontSize: "64px",
                textAlign: "center",
                paddingTop: "32px"
            }}>Waiting for Robot Availability</Typography> */}
            <Typography sx={{
                fontSize: "22px",
                textAlign: "left",
                paddingTop: "32px"
            }}>
                {"There is " + numberOfTask + " more delivery for MEDi to complete \n"}
            </Typography>
            <Typography sx={{
                fontSize: "18px",
                textAlign: "left",
                paddingBottom: "12px",
            }}>
                ETA 10 mins
            </Typography>
            <Box sx = {{
                paddingBottom: "24px"
            }}>
                <IconButton sx={{
                    border: "4px solid #F53649",
                    padding: "32px",
                    width: "256px",
                    height: "256px",
                }}
                onClick={handleSubmit}>
                    <Box>
                        {/* <Sensors sx={{
                            width: "128px",
                            height: "128px",
                            color: "#1976d2"
                        }}/> */}
                        <Typography fontWeight={"bold"} sx ={{
                            fontSize: "32px",
                            color: "#F53649"
                        }}>Cancel Request</Typography>
                    </Box>
                </IconButton>
            </Box>
    </Stack>
    
    </>
}